export default {
  date: 'Päivämäärä',
  chooseExpDate: 'Valitse päivämäärä',
  filterExpDate: 'Suodata päivämäärän mukaan',
  experienceType: 'Tyyppi',
  filterExperienceType: 'Suodata tyypin mukaan',
  experienceVibe: 'Tunnelma',
  filterExperienceVibe: 'Suodata tunnelman mukaan',
  search: 'Hae',
  viewCalendar: 'Kalenteri',
  back: 'Takaisin',
  previous: 'Edellinen',
  next: 'Seuraava',
  noExperiences: 'Ei elämyksiä',
  cancelChanges: 'Peruuta muutokset',
  saveChanges: 'Tallenna muutokset',
  removeFromReservation: 'Poista varauksesta',
  addToCart: 'Lisää ostoskoriin',
  proceedToCheckout: 'Siirry kassalle',
  selectDate: 'Valitse päivämäärä',
  startDate: 'Alkamispäivä',
  endDate: 'Päättymispäivä',
  submit: 'Lähetä',
  filterExperienceTypeScreenReader:
    'Käytä näitä suodattimia tulosten rajaamiseen. Sisältö päivittyy automaattisesti, kun suodatin valitaan.',
};
